import IdentityNullState from './IdentityNullState';

export default IdentityNullState;
